export default __webpack_public_path__ + "navigation-examples-predictive-caching-thumbnail-960-c982394bdd22af16831f82fda52369cc.png";